export function getPercentage(n: number, size: number) {
	return (n / size) * 100;
}
